import { Directive, ElementRef, Input, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltipSimple]'
})
export class TooltipSimpleDirective {
  @Input('appTooltipSimple') text = '';
  private tooltipEl?: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  show() {
    if (!this.text) return;
    this.tooltipEl = this.renderer.createElement('div');
    this.renderer.appendChild(
      document.body,
      this.tooltipEl
    );
    this.renderer.setStyle(this.tooltipEl, 'position', 'fixed');
    this.renderer.setStyle(this.tooltipEl, 'background', 'var(--color-neutral-900)');
    this.renderer.setStyle(this.tooltipEl, 'color', 'var(--color-text-inverse)');
    this.renderer.setStyle(this.tooltipEl, 'padding', '0.375rem 0.5rem');
    this.renderer.setStyle(this.tooltipEl, 'border-radius', 'var(--radius-base)');
    this.renderer.setStyle(this.tooltipEl, 'font-size', 'var(--font-size-xs)');
    this.renderer.setStyle(this.tooltipEl, 'z-index', 'var(--z-index-tooltip)');
    this.renderer.setStyle(this.tooltipEl, 'box-shadow', 'var(--shadow-md)');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');

    const rect = this.el.nativeElement.getBoundingClientRect();
    this.renderer.setProperty(this.tooltipEl, 'innerText', this.text);
    this.renderer.setStyle(this.tooltipEl, 'top', `${rect.top - 36}px`);
    this.renderer.setStyle(this.tooltipEl, 'left', `${rect.left}px`);
  }

  @HostListener('mouseleave')
  hide() {
    if (this.tooltipEl) {
      this.renderer.removeChild(document.body, this.tooltipEl);
      this.tooltipEl = undefined;
    }
  }
}

//<button [appTooltipSimple]="'Approve company'">Approve</button>